import { render, staticRenderFns } from "./AiStatisticsPanel.vue?vue&type=template&id=68a437ca&scoped=true"
import script from "./AiStatisticsPanel.vue?vue&type=script&lang=js"
export * from "./AiStatisticsPanel.vue?vue&type=script&lang=js"
import style0 from "./AiStatisticsPanel.vue?vue&type=style&index=0&id=68a437ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a437ca",
  null
  
)

export default component.exports